/**
 * @author xuna
 */
import Oidc from 'oidc-client'
import { environment } from '@/environments/environment'
import storage from '@/common/storage'
import { superadmin } from '@/common/jdyrole'

const mgr = new Oidc.UserManager(environment.identityConfig)

Oidc.Log.logger = window.console
Oidc.Log.level = Oidc.Log.INFO

mgr.events.addUserLoaded(function (user) {
  console.log('New User Loaded：', arguments)
  console.log('Acess_token: ', user, user.access_token)
})

mgr.events.addAccessTokenExpiring(function () {
  console.log('AccessToken Expiring：', arguments)
})

mgr.events.addAccessTokenExpired(function () {
  console.log('AccessToken Expired：', arguments)
  // mgr.signoutRedirect().then(function (resp) {
  //  console.log('signed out', resp);
  // }).catch(function (err) {
  //  console.log(err)
  // })
})

mgr.events.addSilentRenewError(function () {
  console.log('Silent Renew Error：', arguments)
})

mgr.events.addUserSignedOut(function () {
  console.log('UserSignedOut：', arguments)
  // mgr.removeUser().then(res => {
  //  mgr.signoutRedirect().then(function (resp) {
  //    console.log('signed out', resp);
  //  }).catch(function (err) {
  //    console.log(err)
  //  })
  // });
})

let allowNav = []
allowNav.push({
  name: 'order',
  path: '/order',
  title: '业务中心',
  icons: 'icon-business',
  sub: [
    { name: 'orderClaimlist', path: '/order/orderClaim/list', title: '订单认领' },
    { name: 'businesslist', path: '/order/business/list', title: '业务管理' },
    { name: 'orderlist', path: '/order/list', title: '订单管理' },
    { name: 'productionlist', path: '/order/production/list', title: '生产管理' }
  ]
})
allowNav.push({
  name: 'service',
  path: '/service',
  title: '服务中心',
  icons: 'icon-service',
  sub: [
    { name: 'projectlist', path: '/service/project/projectlist', title: '项目列表' },
    { name: 'projectSet', path: '/service/project/projectSet', title: '项目设置' },
    { name: 'projectLineUp', path: '/service/project/LineUp', title: '排队情况' }
  ]
})
allowNav.push({
  name: 'ecology',
  path: '/ecology',
  title: '生态管理',
  icons: 'icon-ecology',
  sub: [
    { name: 'productlist', path: '/ecology/product/index', title: '产品管理' },
    { name: 'productseries', path: '/ecology/product-series/list', title: '产品系列' },
    { name: 'newwezhanproductseries', path: '/ecology/new-product-series/list', title: '新微站产品系列' },
    { name: 'productplugin', path: '/ecology/product-plugin/list', title: '插件管理' },
    { name: 'wezhanconfig', path: '/wezhanconfig', title: '微站配置' },
    { name: 'componentManage', path: '/ecology/component-manage', title: '语义化组件管理' },
    { name: 'columnManage', path: '/ecology/column-manage', title: '栏目内容管理' }

  ]
})
allowNav.push({
  name: 'userHome',
  path: '/userHome',
  title: '用户首页',
  icons: 'icon-userHome',
  sub: [
    { name: 'announcement', path: '/userHome/announcement', title: '公告栏' },
    { name: 'versionupdate', path: '/userHome/versionUpdate', title: '版本更新栏' }
  ]
})
allowNav.push({
  name: 'system',
  path: '/system',
  title: '系统管理',
  icons: 'icon-system',
  sub: [
    { name: 'staffmessage', path: '/system/staffmessage', title: '员工管理' },
    { name: 'channelmessage', path: '/system/channelmessage', title: '渠道管理' },
    { name: 'rolemessage', path: '/system/rolemessage', title: '角色管理' },
    { name: 'myhome', path: '/system/myhome', title: '个人主页' },
    { name: 'messagecenter', path: '/system/messagecenter', title: '通知函管理' },
    { name: 'serviceProvider', path: '/system/serviceProvider', title: '服务商管理' }
  ]
})

let userNav = null

export default class IdentityService {
  constructor (axios) {
    this.returnUrlStorageKey = 'vuex_oidc_authroute'
    this.userKey = `oidc.user:${environment.identityConfig.authority}:${environment.identityConfig.client_id}`
    this.storage = storage
    this.axios = axios
    this.isGetFromIdentity = false
  }
  /**
   * 获取当前用户
   * */
  getUser () {
    let storageUser = this.storage.getItem(this.userKey)
    if (storageUser) {
      return JSON.parse(storageUser)
    }
    return null
  }
  /**
   * 获取用户对象
   * */
  getUserProfile () {
    return this.getUser().profile
  }
  /**
   * @method
   *
   * */
  isAuthenticated () {
    let user = this.getUser()
    if (user == null) { return false }

    if (!this.isGetFromIdentity) {
      this.isGetFromIdentity = true
      let that = this
      mgr.getUser().then(function (mgruser) {
        if (!mgruser || mgruser.expired) {
          console.log('getUser Expired')
          that.signOut()
        }
      }).catch(err => {
        console.log(err)
      })
    }
    let expired = user.expires_at <= parseInt((new Date()).valueOf() / 1000)
    console.log('expired:', expired)
    return !expired
  }
  /**
   * 存储登录跳转地址
   */
  storageReturnUrl (url) {
    let returnUrl = url || (document.location.pathname + document.location.search)
    this.storage.setItem(this.returnUrlStorageKey, returnUrl)
  }

  /**
   * 跳转登录页面
   */
  signIn () {
    this.storageReturnUrl()
    window.location.href = '/login.html?returnUrl=' + returnUrl
  }
  /**
   * 跳转到验证中心登录页
   */
  signInRedirect () {
    mgr.signinRedirect().catch(function (err) { console.log(err) })
  }
  /**
   * 登出
   */
  signOut () {
    this.storage.removeItem(this.userKey)
    this.isGetFromIdentity = false
    mgr.signoutRedirect()
      .then(function (resp) {
      }).catch(function (err) {
        console.log(err)
      })
  }
  /**
   * 权限验证
   * @method
   * @param {Route} route 路由对象
   * 例：
   * {
   *    route:Route
   * }
   * @returns {boolean} 是否允许
   * @desc 根据路由验证登录权限
   */
  // checkAccess(route) {
  //  let hasAccess = true;
  //  // 验证登录
  //  if (route.matched.some(record => record.meta.requiresAuth)) {
  //    if (!this.isAuthenticated()) {
  //      this.signIn();
  //      hasAccess = false;
  //    }
  //  }
  //  // 验证角色
  //  if (hasAccess && route.meta.requiresRole) {
  //    if (!this.checkRole(route.meta.roleRequire)) {
  //      console.log("checkrole", false);
  //      hasAccess = false;
  //    }
  //  }
  //  return hasAccess;
  // }

  /**
   * 验证角色
   * @param {any} role
   */
  checkRole (role) {
    let user = this.getUser()
    if (user && user.profile && user.profile.role) {
      let userRole = user.profile.role
      if (typeof (userRole) === 'string') {
        if (userRole == superadmin) {
          return true
        }
        if (typeof (role) === 'string') {
          return userRole == role
        } else {
          if (typeof (role) === 'object') {
            for (let i = 0; i < role.length; i++) {
              if (userRole == role[i]) {
                return true
              }
            }
          }
        }
      } else {
        if (typeof (role) === 'string') {
          for (let i = 0; i < userRole.length; i++) {
            if (userRole[i] == superadmin) {
              return true
            }
            if (userRole[i] == role) {
              return true
            }
          }
        } else {
          for (let i = 0; i < userRole.length; i++) {
            if (userRole[i] == superadmin) {
              return true
            }
            if (typeof (role) === 'object') {
              for (let cki = 0; cki < role.length; cki++) {
                if (userRole[i] == role[cki]) {
                  return true
                }
              }
            }
          }
        }
      }
    }
    return false
  }
  /**
   *  登录回调方法
   * */
  signInCallback () {
    let that = this
    return new Promise((resolve, reject) => {
      mgr.signinRedirectCallback()
        .then(function (user) {
          that.isGetFromIdentity = true
          resolve(that.storage.getItem(that.returnUrlStorageKey) || '/')
        })
        .catch(function (err) {
          reject(err)
        })
    })
  }
  /**
   * 刷新回调
   * */
  signinSilentCallback () {
    mgr.signinSilentCallback()
  }
  /**
   * 获取导航菜单
   * */
  getNav () {
    return new Promise((resolve, reject) => {
      if (userNav == null) {
        this.getUserNav().then(res => {
          userNav = res
          resolve(res)
        })
      } else {
        resolve(allowNav)
      }
    })
  }
  getUserNav () {
    return new Promise((resolve, reject) => {
      this.axios.get(`${environment.apiUrl}/api/v1/role`)
        .then(res => {
          let userRoles = res.data

          // let temp = {
          //   id: 123239,
          //   inRole: true,
          //   name: 'columnManage',
          //   path: '/ecology/column-manage',
          //   title: '栏目内容管理'
          // }
          // let userRoles = [...res.data, temp]
          for (let i = 0; i < allowNav.length; i++) {
            let nav = allowNav[i]
            for (let ui = 0; ui < userRoles.length; ui++) {
              let unav = userRoles[ui]
              if (nav.name == unav.name) {
                Object.assign(nav, unav)
              }
            }
            if (nav.sub) {
              for (let si = 0; si < nav.sub.length; si++) {
                let subnav = nav.sub[si]
                for (let ui = 0; ui < userRoles.length; ui++) {
                  let unav = userRoles[ui]

                  if (subnav.name == unav.name) {
                    Object.assign(subnav, unav)
                    if (unav.inRole) { nav.inRole = true }
                  }
                }
              }
            }
          }
          resolve(allowNav)
        })
        .catch(err => {
          reject(err)
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/service/identity.js